<div *ngIf="chaseDetails != null" class="iframe_react_container">
  <div *ngIf="!isVisible; else nextGen">
    <member-chase-detail-chart [chaseDetailsForAudit]="chaseDetails"
    [enablePopUpBtn]="false"></member-chase-detail-chart>
  </div>
  <ng-template #nextGen>
    <app-iframe [visible]="isVisible" [load]="true" iframeSrc="{{iframeSrc}}" classes="{{classes}}"></app-iframe>
</ng-template>
